import styled from 'styled-components'

export const GenresPageContainer = styled.div`
  width: 80%;
  margin: 0 auto;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const SearchTile = styled.h1`
  padding-left: 20px;
  align-self: start;
  color: white;
  font-size: 1.9rem;
`
